import { useCurrentUser } from "vuefire";

export const getAuthHeader = async () => {
  const authStore = useAuthStore();
  const customToken = authStore.accessToken;

  if (customToken) {
    return { Authorization: `Bearer ${customToken}` };
  }

  // Phase 1/2 fallback — removed in Phase 3
  const firebaseToken = await useCurrentUser().value?.getIdToken();
  return { Authorization: `Bearer ${firebaseToken}` };
};
